import React from "react";
import {
  TwoColumnSectionBase,
  IconTitleDescriptionActionCard,
} from "@reusejs/react";
import CommercialPlaceHolderIcon from "../../Icons/CommercialPlaceHolderIcon";
import AgriculturePlaceHolderIcon from "../../Icons/AgriculturePlaceHolderIcon";
import ResidencialPlaceHolderIcon from "../../Icons/ResidencialPlaceHolderIcon";

const PlaceholderComponent = () => {
  const LeftSection = (
    <div className="flex flex-col my-4 lg:my-0">
      <h1 className="text-3xl font-extrabold text-gray-900">
        Unique range of 1000+ bank auctioned properties to choose from!
      </h1>
      <div className="flex flex-col mt-6">
        <p className="text-xl font-normal my-4 text-gray-500 lg:pr-16 md:text-justify">
          At AuctionBazaar, you&#39;ll find a wide range of NPA bank properties
          for sale, from residential homes to commercial spaces, listing all
          Banks and Financial institutions&#39; stressed assets. We have covered
          you with unique 1000+ listed properties on our portal to browse
          seamlessly and transact through your dream property.
        </p>
        <p className="text-xl font-normal text-gray-500 my-4 lg:pr-16 md:text-justify ">
          All our properties are available for{" "}
          <a href="https://www.auctionbazaar.com/" className="text-blue-600">
            online property auctions
          </a>{" "}
          so you can bid from the comfort of your home.
        </p>
        <p className="text-xl font-normal text-gray-500 my-4 lg:pr-16 md:text-justify">
          <a
            className="text-blue-600"
            href="https://economictimes.indiatimes.com/wealth/personal-finance-news/estimated-rs-7700-crore-worth-realty-npas-up-for-sale-report/articleshow/28194224.cms?utm_source=contentofinterest&amp;utm_medium=text&amp;utm_campaign=cppst"
          >
            According to an industry report, an estimated Rs 7,700 crore worth
            of commercial and residential property loans are up for sale.
          </a>
        </p>
      </div>
    </div>
  );

  const rightSection = [
    {
      icon: <CommercialPlaceHolderIcon />,
      title: "Commercial Properties:",
      description:
        "Commercial properties are buildings or land used for business purposes. These asset subtypes are commercial plots, malls, offices and shops. Browse and start bidding as per your needs, location and preferences.",
    },
    {
      icon: <ResidencialPlaceHolderIcon />,
      title: "Residential Properties:",
      description:
        "Residential properties are buildings or land used for housing. These asset subtypes are residential plots, individual houses, plots, bungalows, farmhouses and villas.",
    },
    {
      icon: <AgriculturePlaceHolderIcon />,
      title: "Agricultural Properties:",
      description:
        "Agricultural properties are land or buildings used for farming or agricultural purposes. These asset subtypes are crop fields, orchards, and farms.",
    },
    {
      icon: <CommercialPlaceHolderIcon />,
      title: "Industrial Properties:",
      description:
        "Industrial properties are buildings or land used for manufacturing, production, or storage. These asset subtypes are industrial plots, industrial sheds, plant and machinery, and sheds with plant and machinery.",
    },
  ];

  const RightSections = rightSection.map((item: any, index: any) => {
    return (
      <>
        <div className="flex lg:hidden">
          <IconTitleDescriptionActionCard
            key={index}
            title={item.title}
            icon={item.icon}
            description={item.description}
            iconPosition="top-left"
            itemTitleDescriptionCardBaseClasses={{
              wrapper: "bg-white lg:bg-gray-50 p-4 lg:p-0 mt-4 lg:mt-0",
              iconWrapper:
                "flex h-12 w-12 items-center justify-center rounded-md text-white",
              titleWrapper: "mt-5 text-left",
              titleStyles:
                "md:text-lg leading-6 font-bold text-md text-gray-900",
              descriptionWrapper: "text-left mt-2",
              descriptionStyles: "text-sm md:text-base text-gray-500 my-4",
              actionWrapper: "mt-2 text-left",
            }}
          />
        </div>
        <div className="hidden lg:flex" key={`${index}_2`}>
          <IconTitleDescriptionActionCard
            key={index}
            title={item.title}
            icon={item.icon}
            description={item.description}
            iconPosition="left"
            itemTitleDescriptionCardBaseClasses={{
              wrapper: "",
              iconWrapper:
                "flex h-12 w-12 items-center justify-center rounded-md text-white",
              titleWrapper: "mt-5 text-left",
              titleStyles:
                "text-md leading-6 font-bold md:text-lg text-gray-900",
              descriptionWrapper: "text-left mt-2",
              descriptionStyles: "text-sm md:text-base text-gray-500",
              actionWrapper: "mt-2 text-left",
            }}
          />
        </div>
      </>
    );
  });

  const RightSection = (
    <div className="flex flex-col">
      <div className="flex flex-col md:flex-row bg-white rounded-md p-5 lg:p-0 lg:bg-gray-50">
        <div className="flex">
          <CommercialPlaceHolderIcon />
        </div>
        <div className="flex flex-col md:ml-4">
          <h1 className="text-lg md:text-xl font-bold text-gray-900">
            Commercial Properties:
          </h1>
          <p className="text-sm md:text-base font-normal text-gray-500 md:text-justify mt-2">
            Commercial properties are buildings or land used for business
            purposes. These asset subtypes are commercial plots, malls, offices
            and shops. Browse and start bidding as per your needs, location and
            preferences.
          </p>
        </div>
      </div>
      <div className="flex mt-6 flex-col md:flex-row bg-white rounded-md p-5 lg:p-0 lg:bg-gray-50">
        <div className="flex">
          <ResidencialPlaceHolderIcon />
        </div>
        <div className="flex flex-col md:ml-4">
          <h1 className="text-lg md:text-xl font-bold text-gray-900">
            Residential Properties:
          </h1>
          <p className="text-sm md:text-base font-normal text-gray-500 md:text-justify mt-2">
            Residential properties are buildings or land used for housing. These
            asset subtypes are residential plots, individual houses, plots,
            bungalows, farmhouses and villas.
          </p>
        </div>
      </div>
      <div className="flex mt-6 flex-col md:flex-row bg-white rounded-md p-5 lg:p-0 lg:bg-gray-50">
        <div className="flex">
          <AgriculturePlaceHolderIcon />
        </div>
        <div className="flex flex-col md:ml-4">
          <h1 className="text-lg md:text-xl font-bold text-gray-900">
            Agricultural Properties:
          </h1>
          <p className="text-sm md:text-base font-normal text-gray-500 md:text-justify mt-2">
            Agricultural properties are land or buildings used for farming or
            agricultural purposes. These asset subtypes are crop fields,
            orchards, and farms.
          </p>
        </div>
      </div>
      <div className="flex mt-6 flex-col md:flex-row bg-white rounded-md p-5 lg:p-0 lg:bg-gray-50">
        <div className="flex">
          <CommercialPlaceHolderIcon />
        </div>
        <div className="flex flex-col md:ml-4">
          <h1 className="text-lg md:text-xl font-bold text-gray-900">
            Industrial Properties:
          </h1>
          <p className="text-sm md:text-base font-normal text-gray-500 md:text-justify mt-2">
            Industrial properties are buildings or land used for manufacturing,
            production, or storage. These asset subtypes are industrial plots,
            industrial sheds, plant and machinery, and sheds with plant and
            machinery.
          </p>
        </div>
      </div>
    </div>
  );
  return (
    <div className="flex my-10 bg-gray-50">
      <TwoColumnSectionBase
        firstColumnEl={LeftSection}
        secondColumnEl={RightSections}
        twoColumnSectionBaseClasses={{
          columnsFlexWrapperStyles:
            "max-w-7xl m-auto flex flex-col lg:flex-row py-10 px-4 lg:px-8",
          firstElWrapperStyles: "w-full lg:w-1/2",
          secondElWrapperStyles: "w-full lg:w-1/2",
        }}
      />
    </div>
  );
};

export default PlaceholderComponent;
